import { render } from "./ExpensesBodyCz.vue?vue&type=template&id=f98271cc&scoped=true"
import script from "./ExpensesBodyCz.vue?vue&type=script&lang=js"
export * from "./ExpensesBodyCz.vue?vue&type=script&lang=js"

import "./ExpensesBodyCz.vue?vue&type=style&index=0&id=f98271cc&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f98271cc"]])

export default __exports__